export const INITIAL_DATA = {
  pColor: "",
  sColor: "",
  fNamePrefix: "",
  fName: "",
  lName: "",
  lNameSuffix: "",
  email: "",
  email2: "",
  address: "",
  postalAddress: "",
  company: "",
  mobile: "",
  mobile2: "",
  jobTitle: "",
  link: "",
  phone: "",
  phone2: "",
  webLinks: [],
  images: [],
  bgImage: "",
  summary: "",
  showQr: undefined,
  qrSetting: undefined,
  socialLinks: [
    { name: "facebook", link: "", active: false },
    { name: "instagram", link: "", active: false },
    { name: "linkedin", link: "", active: false },
    { name: "twitter", link: "", active: false },
    { name: "skype", link: "", active: false },
    { name: "behance", link: "", active: false },
    { name: "youtube", link: "", active: false },
    { name: "whatsapp", link: "", active: false },
    { name: "maps", link: "", active: false },
    { name: "mail", active: false },
    { name: "telegram", link: "", active: false },
    { name: "tiktok", link: "", active: false },
    { name: "snapchat", link: "", active: false },
  ],
};
